(function () {
  if (window.__CartRewardsBootstrapped) return;
  window.__CartRewardsBootstrapped = true;

  window.CartRewardsState = window.CartRewardsState || { cartTotal: 0, p1: 0, p2: 0 };

  // Legacy: motyw nie renderuje juz .cart-rewards-container / .cart-rewards-config
  // (pasek nagrod przejal assets/cart-rewards.js). Bez markupu ten blok nie mial
  // czego malowac, a jego hooki robily 1-3 zbedne GET /cart.js po kazdej mutacji
  // koszyka i nadpisywaly CartRewardsState kwota Z gratisami.
  // Usun ten guard, jesli sekcja z .cart-rewards-container wroci do motywu.
  if (!document.querySelector('.cart-rewards-container, .cart-rewards-config')) return;

  const $  = (s,r=document)=>r.querySelector(s);
  const $$ = (s,r=document)=>Array.from(r.querySelectorAll(s));
  const debounce = (fn,ms=200)=>{let t;return(...a)=>{clearTimeout(t);t=setTimeout(()=>fn(...a),ms)}};
  const sleep = (ms)=>new Promise(r=>setTimeout(r,ms));
  let syncing=false;

  // helpers
  const toNumber = (v)=>{
    if (typeof v === "number") return v;
    const n = parseFloat(String(v).replace(/[^\d.,-]/g,"").replace(",",".")); 
    return Number.isFinite(n) ? n : NaN;
  };

  const rewardsInstances = new Set();
  function renderAllRewards(){
    rewardsInstances.forEach(inst => {
      if (inst?.container && !inst.container.isConnected){
        rewardsInstances.delete(inst);
        return;
      }
      try { inst?.render?.(); } catch(e){ /* ignore */ }
    });
  }

  async function fetchCartStable(maxTries=4){
    if(syncing) return;
    syncing=true;
    try{
      for(let i=0;i<maxTries;i++){
        const res=await fetch("/cart.js",{headers:{Accept:"application/json"},cache:"no-store",credentials:"same-origin"});
        const cart=await res.json();
        const newTotal=(cart.total_price||0)/100;
        if(newTotal===0 && (cart.item_count||0)>0){await sleep(120);continue;}
        window.CartRewardsState.cartTotal=newTotal;
        break;
      }
    }catch(e){console.warn("CartRewards fetch error",e);}
    finally{syncing=false;}
    renderAllRewards();
  }
  const syncDebounced = debounce(fetchCartStable,180);

  function initInstance(container){
    if (!container || container.dataset.rewardsInited==="1") return;

    const wrapper=container.closest(".cart-rewards-wrapper")||container;
    const cfgEl = wrapper.previousElementSibling?.classList?.contains("cart-rewards-config")
      ? wrapper.previousElementSibling
      : wrapper.querySelector(".cart-rewards-config");
    if (!cfgEl) return;

    let RAW={};
    try { RAW = JSON.parse(cfgEl.textContent.trim()); } catch { return; }

    // sanitize thresholds
    let thresholds = (RAW.thresholds||[])
      .map(toNumber).filter(n=>Number.isFinite(n))
      .concat([0]).filter((v,i,a)=>a.indexOf(v)===i)
      .sort((a,b)=>a-b);
    if (thresholds[0] !== 0) thresholds.unshift(0);
    if (thresholds.length < 3) {
      const t1 = thresholds[1] ?? 200;
      const t2 = thresholds[2] ?? 400;
      thresholds = [0, toNumber(t1)||200, toNumber(t2)||400].sort((a,b)=>a-b);
      if (thresholds[0] !== 0) thresholds.unshift(0);
    }

    const CONFIG = {
      thresholds,
      icons: RAW.icons || {},
      finalProduct: RAW.finalProduct || {},
      messages: RAW.messages || {
        phase1: { before: "Dodaj produkty za", after: "i obniż koszt dostawy" },
        phase2: { before: "Dodaj za",          after: "aby odebrać nagrodę za 1 zł" },
        complete: "🎉 Gratulacje! Wszystkie nagrody odblokowane"
      },
      currency: RAW.currency || "zł"
    };

    const seg=(total,i)=>{
      const s=CONFIG.thresholds[i], e=CONFIG.thresholds[i+1];
      if (e==null) return 100;
      if (total<=s) return 0;
      if (total>=e) return 100;
      return ((total-s)/(e-s))*100;
    };

    const smoothWidth=(el,to)=>{
      if(!el) return;
      const cur=parseFloat(el.style.width)||0;
      if(Math.abs(cur-to)<0.2) return;
      el.style.transition="width .6s ease";
      el.style.width=to+"%";
    };

    const hydrateIcons=()=>{
      const s1=container.querySelector(".circle-1 .circle-icon-slot");
      const s2=container.querySelector(".circle-2 .circle-icon-slot");
      if(s1 && CONFIG.icons?.start)    s1.innerHTML=CONFIG.icons.start;
      if(s2 && CONFIG.icons?.shipping) s2.innerHTML=CONFIG.icons.shipping;
    };

    function render(){
      hydrateIcons();

      const total = window.CartRewardsState.cartTotal;
      const p1 = seg(total,0), p2 = seg(total,1);
      window.CartRewardsState.p1=p1; window.CartRewardsState.p2=p2;

      smoothWidth(container.querySelector(".fill-1"), p1);
      smoothWidth(container.querySelector(".fill-2"), p2);

      // circles/badges
      container.querySelectorAll(".progress-circle, .progress-circle-wrapper").forEach((c,i)=>{
        const t=CONFIG.thresholds[i] ?? CONFIG.thresholds.at(-1);
        const done = total >= t;
        if (c.classList.contains("progress-circle-wrapper")){
          c.querySelector(".circle-3")?.classList.toggle("completed",done);
          const badge=c.querySelector(".completion-badge");
          const price=c.querySelector(".price-badge");
          const br   =c.querySelector(".breathing-border");
          if(badge) badge.style.display=done?"flex":"none";
          if(price) price.style.display=done?"none":"block";
          if(br)    br.style.display   =done?"none":"block";
        } else {
          c.classList.toggle("completed",done);
        }
      });

      // price markers
      container.querySelectorAll(".segment-price").forEach((el,idx)=>{
        const t=CONFIG.thresholds[idx+1]||0;
        el.classList.toggle("completed", total>=t);
      });

      // messages
      const beforeEl    = container.querySelector(".message-before");
      const afterEl     = container.querySelector(".message-after");
      const amountEl    = container.querySelector(".highlight-amount");
      const msgText     = container.querySelector(".message-text");
      const msgComplete = container.querySelector(".message-complete");

      const t1 = CONFIG.thresholds[1];
      const t2 = CONFIG.thresholds[2];

      if (total >= t2) {
        msgText.style.display = "none";
        msgComplete.style.display = "inline";
      } else if (total >= t1) {
        const diff = Math.max(0, t2 - total).toFixed(2);
        if (beforeEl) beforeEl.textContent = CONFIG.messages.phase2.before;
        if (afterEl)  afterEl.textContent  = CONFIG.messages.phase2.after;
        if (amountEl) amountEl.textContent = `${diff} ${CONFIG.currency}`;
        msgText.style.display = "inline";
        msgComplete.style.display = "none";
      } else {
        const diff = Math.max(0, t1 - total).toFixed(2);
        if (beforeEl) beforeEl.textContent = CONFIG.messages.phase1.before;
        if (afterEl)  afterEl.textContent  = CONFIG.messages.phase1.after;
        if (amountEl) amountEl.textContent = `${diff} ${CONFIG.currency}`;
        msgText.style.display = "inline";
        msgComplete.style.display = "none";
      }
    }

    render();
    container.dataset.rewardsInited="1";
    return { render, container };
  }

  function initAllInstances(){
    $$(".cart-rewards-container").forEach(c => {
      const inst = initInstance(c);
      if (inst) rewardsInstances.add(inst);
    });
  }

  const mo=new MutationObserver((muts)=>{
    if(muts.some(m=>[...m.addedNodes].some(n=>n.querySelector?.(".cart-rewards-container")))){
      initAllInstances();
      syncDebounced();
    }
  });
  mo.observe(document.body,{childList:true,subtree:true});

  // 🔧 HOOK FETCH – reagujemy tylko na MUTACJE koszyka
  function hookNetworkOnce(){
    if(window.__CartRewardsFetchHooked) return;
    window.__CartRewardsFetchHooked = true;

    const orig = window.fetch;

    // Mutacje oznaczone naglowkiem X-GIFT-AUTO pochodza z silnika gratisu.
    // Reagowanie na nie odpalalo kolejna kaskade odswiezania koszyka.
    const isGiftAutoTraffic = (args) => {
      try {
        const init = args[1];
        const h = init && init.headers;
        if (!h) return false;
        if (typeof h.get === "function") return h.get("X-GIFT-AUTO") === "1";
        return h["X-GIFT-AUTO"] === "1" || h["x-gift-auto"] === "1";
      } catch (e) { return false; }
    };

    window.fetch = async function(...args){
      const url = args[0];
      const s = typeof url === "string" ? url : (url?.url || "");

      const isCartMutation = /\/cart\/(add|change|update)\.js/.test(s) && !isGiftAutoTraffic(args);

      const resp = await orig.apply(this, args);
      if(isCartMutation && resp.ok){
        setTimeout(fetchCartStable, 150);
      }
      return resp;
    };
  }

  function hookEventsOnce(){
    if(window.__CartRewardsEventsHooked) return;
    window.__CartRewardsEventsHooked = true;
    [
      "added_to_cart","ajaxProduct:added","cart:add",
      "cart:item:added","cart:update","cart:updated",
      "cart:refresh","line-item:updated"
    ].forEach(evt => document.addEventListener(evt, ()=>syncDebounced()));
    
    document.addEventListener("submit", e => {
      if(e.target?.matches('form[action*="/cart"]')) syncDebounced();
    });
    // Bez sync na focus/visibilitychange - powrot do karty nie jest zmiana koszyka,
    // a wymuszal serie odczytow /cart.js przy kazdym przelaczeniu zakladki.
  }

  async function boot(){
    initAllInstances();
    hookNetworkOnce();
    hookEventsOnce();
    await fetchCartStable();
    $$(".cart-rewards-container").forEach(el=>{
      const f1=el.querySelector(".fill-1"), f2=el.querySelector(".fill-2");
      if(f1) f1.style.width=(window.CartRewardsState.p1||0)+"%";
      if(f2) f2.style.width=(window.CartRewardsState.p2||0)+"%";
    });
  }

  if (document.readyState==="loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();

/* Popup handling – bez zmian */
(function() {
  function openPopup(id) {
    var overlay = document.querySelector('[data-product-popup-overlay="' + id + '"]');
    var popup   = document.querySelector('[data-product-popup="' + id + '"]');
    if (!overlay || !popup) return;

    overlay.classList.add('is-active');
    popup.classList.add('is-active');
    document.documentElement.classList.add('no-scroll-popup-product');
  }

  function closePopup(id) {
    var overlay = document.querySelector('[data-product-popup-overlay="' + id + '"]');
    var popup   = document.querySelector('[data-product-popup="' + id + '"]');
    if (!overlay || !popup) return;

    overlay.classList.remove('is-active');
    popup.classList.remove('is-active');
    document.documentElement.classList.remove('no-scroll-popup-product');
  }

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.js-open-product-popup');
    if (trigger) {
      e.preventDefault();
      var id = trigger.getAttribute('data-product-popup-id');
      if (id) openPopup(id);
      return;
    }

    var overlay = e.target.closest('.product-popup-overlay.is-active');
    if (overlay) {
      var idOverlay = overlay.getAttribute('data-product-popup-overlay');
      if (idOverlay) closePopup(idOverlay);
      return;
    }

    var closeBtn = e.target.closest('[data-product-popup-close]');
    if (closeBtn) {
      var idClose = closeBtn.getAttribute('data-product-popup-close');
      if (idClose) closePopup(idClose);
      return;
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      var active = document.querySelectorAll('.product-popup.is-active');
      for (var i = 0; i < active.length; i++) {
        var id = active[i].getAttribute('data-product-popup');
        if (id) closePopup(id);
      }
    }
  });
})();

/* 🎁 Pakowanie na prezent w mini-koszyku – Z UJEDNOLICONĄ ANIMACJĄ */
/* 🎁 Pakowanie na prezent w mini-koszyku – dodawanie i usuwanie + natychmiastowe odświeżenie */
(function () {
  const MINI_CART_SELECTOR = '#mini-cart';
  const SWITCH_SELECTOR = '#giftwrap-toggle, [data-giftwrap-toggle]';

  // znajdź ID sekcji otaczającej mini-cart (do fallbacku)
  function getMiniCartSectionId() {
    const drawer = document.querySelector(MINI_CART_SELECTOR);
    if (!drawer) return null;

    const wrapper = drawer.closest('[id^="shopify-section-"]');
    if (!wrapper) return null;

    return wrapper.id.replace('shopify-section-', '');
  }

  // fallback do odświeżenia sekcji mini-cart, jeśli motyw nie ma swojej funkcji
  let isRefreshing = false;
  async function refreshMiniCartFallback() {
    if (isRefreshing) return;

    const sectionId = getMiniCartSectionId();
    if (!sectionId) {
      console.warn('Giftwrap: nie udało się znaleźć sectionId dla mini-cart');
      return;
    }

    const oldSection = document.querySelector('#shopify-section-' + CSS.escape(sectionId));
    if (!oldSection) return;

    // zapamiętujemy, czy drawer był otwarty
    const oldDrawer = oldSection.querySelector(MINI_CART_SELECTOR);
    const wasOpen =
      oldDrawer &&
      (
        oldDrawer.hasAttribute('open') ||
        oldDrawer.classList.contains('is-open') ||
        oldDrawer.classList.contains('drawer--is-open')
      );

    isRefreshing = true;

    try {
      const res = await fetch('/?section_id=' + encodeURIComponent(sectionId), {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      });

      if (!res.ok) {
        throw new Error('Mini-cart refresh failed');
      }

      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;

      const newSection = tmp.querySelector('#shopify-section-' + CSS.escape(sectionId));
      if (!newSection) {
        console.warn('Giftwrap: brak sekcji w odpowiedzi');
        return;
      }

      oldSection.replaceWith(newSection);

      // jeżeli przedtem był otwarty → otwórz znowu
      if (wasOpen) {
        const newDrawer = document.querySelector(MINI_CART_SELECTOR);
        if (newDrawer) {
          newDrawer.setAttribute('open', '');
          newDrawer.classList.add('is-open', 'drawer--is-open');
          newDrawer.removeAttribute('aria-hidden');
        }
      }
    } catch (e) {
      console.error('refreshMiniCartFallback error', e);
    } finally {
      isRefreshing = false;
    }
  }

  // spróbuj użyć FUNKCJI MOTYWU, a jak nie ma – fallback
  function refreshMiniCart() {
    try {
      if (
        typeof Shopify !== 'undefined' &&
        Shopify.theme &&
        Shopify.theme.cartDrawer &&
        typeof Shopify.theme.cartDrawer.refreshCart === 'function'
      ) {
        Shopify.theme.cartDrawer.refreshCart();
        return;
      }
    } catch (e) {
      console.warn('Giftwrap: built-in cart refresh failed, fallback', e);
    }

    // fallback
    refreshMiniCartFallback();
  }

  // helper: odpalamy eventy koszykowe
  function dispatchCartEvents(cart, mode) {
    const eventsOnAdd = [
      'added_to_cart',
      'ajaxProduct:added',
      'cart:add',
      'cart:item:added',
      'cart:update',
      'cart:updated',
      'cart:refresh',
      'line-item:updated'
    ];

    const eventsOnRemove = [
      'cart:update',
      'cart:updated',
      'cart:refresh',
      'line-item:updated'
    ];

    const list = mode === 'add' ? eventsOnAdd : eventsOnRemove;

    list.forEach((name) => {
      document.dispatchEvent(new CustomEvent(name, { detail: cart }));
    });
  }

  // UI – stan kafelka i switcha
  function setGiftwrapUIState(btn, isActive) {
    const state = isActive ? 'checked' : 'unchecked';

    btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
    btn.setAttribute('data-state', state);
    btn.classList.toggle('giftwrap-switch--active', isActive);

    const thumb =
      btn.querySelector('.giftwrap-switch__thumb') ||
      btn.querySelector('[data-giftwrap-thumb]');
    if (thumb) {
      thumb.setAttribute('data-state', state);
    }

    const card = btn.closest('.giftwrap-card, .mini-cart__giftwrap-card');
    if (card) {
      card.setAttribute('data-giftwrap-active', isActive ? 'true' : 'false');
      card.classList.toggle('giftwrap-card--active', isActive);
    }
  }

async function handleGiftwrapClick(e) {
  const btn = e.target.closest(SWITCH_SELECTOR);
  if (!btn) return;

  e.preventDefault();

  if (btn.disabled) return;
  btn.disabled = true;

  // 🔄 START LOADING – wizualny stan ładowania
  const card = btn.closest('.giftwrap-card, .mini-cart__giftwrap-card');
  if (card) {
    card.classList.add('is-loading');
  }
  btn.setAttribute('data-loading', 'true');
  btn.setAttribute('aria-busy', 'true');

  const rawId = btn.getAttribute('data-variant-id');
  const variantId = rawId ? parseInt(rawId, 10) : NaN;

  if (!variantId || isNaN(variantId)) {
    console.error('Giftwrap: nieprawidłowe data-variant-id:', rawId);
    // 🔄 STOP LOADING przy błędzie
    if (card) card.classList.remove('is-loading');
    btn.removeAttribute('data-loading');
    btn.removeAttribute('aria-busy');
    btn.disabled = false;
    return;
  }

  const currentlyActive = btn.getAttribute('aria-checked') === 'true';
  const willBeActive = !currentlyActive;

  try {
    if (willBeActive) {
      // ✅ DODANIE PAKOWANIA – jak normalny produkt / gratis
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      const cart = await res.json();
      if (!res.ok) throw cart;

      setGiftwrapUIState(btn, true);
      dispatchCartEvents(cart, 'add');
      refreshMiniCart();

      // brak dodatkowego refreshMiniCart – motyw i eventy robią swoje
    } else {
      // ❌ USUNIĘCIE PAKOWANIA – jak usunięcie gratisu
      const cartRes = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      const cart = await cartRes.json();

      const index = cart.items.findIndex(function (item) {
        return item.variant_id === variantId;
      });

      if (index === -1) {
        console.warn('Giftwrap: nie znaleziono pozycji z wariantem', variantId);
        setGiftwrapUIState(btn, false);
        return;
      }

      // Adresujemy po kluczu pozycji, nie po indeksie. Indeks odczytany z /cart.js
      // jest juz nieaktualny, jesli cokolwiek innego zdazylo zmienic koszyk miedzy
      // odczytem a zapisem - a wtedy kasowalismy niewlasciwy produkt.
      const lineKey = cart.items[index].key;

      const changeRes = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      });

      const newCart = await changeRes.json();
      if (!changeRes.ok) throw newCart;

      setGiftwrapUIState(btn, false);
      dispatchCartEvents(newCart, 'remove');

      // 🔁 przeładowanie mini-koszyka po usunięciu
      refreshMiniCart();
    }
  } catch (err) {
    console.error('Giftwrap toggle error', err);
    // można tu dorzucić np. toast/alert
  } finally {
    // 🔄 STOP LOADING – zawsze na końcu
    if (card) {
      card.classList.remove('is-loading');
    }
    btn.removeAttribute('data-loading');
    btn.removeAttribute('aria-busy');
    btn.disabled = false;
  }
}


  // delegacja – działa także po podmianie mini-koszyka
  document.addEventListener('click', handleGiftwrapClick);
})();